<template>
    <div class="verified-input">
        <VerifiedLable
            :id="id"
            :title="title"
            :tagnewid="tagnewid"
            :required="required"
            :disableMLtitle="disableMLtitle"
            :tooltipLabel="tooltipLabel"
            :tooltipPosition="tooltipPosition"
            :tooltipType="tooltipType"
            :tooltipSize="tooltipSize"
            :tooltipMultilined="tooltipMultilined"
        />
        <div :class="icon ? 'field has-addons' : ''">
            <div :class="icon ? 'control is-expanded' : ''">
                <the-mask
                    ref="maskInput"
                    :masked="masked"
                    :id="id == null ? innerId : id"
                    :type="type"
                    :value="value"
                    :mask="mask"
                    :placeholder="
                        disableMLplaceholder
                            ? placeholder
                            : getT(placeholder, '')
                    "
                    :class="{ invalid: focusedOut && invalid }"
                    :tokens="tokens"
                    @input="updateValue"
                    @change="onChangeFunc"
                    @focus.native="focusEvt()"
                    @blur.native="blurEvt()"
                    :disabled="disabled"
                    :readonly="readonly"
                />
            </div>
            <div class="control" v-if="icon">
                <a
                    class="button"
                    @click="inputAction"
                    :class="{ 'invalid-button': focusedOut && invalid }"
                >
                    <b-icon :icon="icon" />
                </a>
            </div>
        </div>
        <span
            class="validation"
            v-text="getT(msg, '')"
            v-if="focusedOut && invalid"
        />
    </div>
</template>

<script>
import VerifiedLable from '@/components/shared/VerifiedLable.vue';

export default {
    components: {
        VerifiedLable,
    },
    props: {
        value: {
            default: null,
        },
        id: {
            default: null,
        },
        placeholder: {
            default: '',
            type: String,
        },
        title: {
            default: '',
            type: String,
        },
        mask: {
            type: [String, Array],
            default: () => [],
        },
        msg: {
            default: 'msg-campo-obrigatorio',
            type: String,
        },
        type: {
            default: '',
            type: String,
        },
        invalid: {
            default: false,
            type: Boolean,
        },
        masked: {
            default: false,
            type: Boolean,
        },
        blur: {
            default: true,
            type: Boolean,
        },
        disabled: {
            default: false,
            type: Boolean,
        },
        readonly: {
            default: false,
            type: Boolean,
        },
        onBlur: {
            type: Function,
            default: () => {},
        },
        tokens: {
            default: () => {
                return {
                    '#': { pattern: /\d/ },
                    X: { pattern: /[0-9a-zA-Z]/ },
                    S: { pattern: /[a-zA-Z]/ },
                    A: { pattern: /[a-zA-Z]/, transform: (v) => v.toLocaleUpperCase() },
                    a: { pattern: /[a-zA-Z]/, transform: (v) => v.toLocaleLowerCase() },
                    '!': { escape: true },
                };
            },
        },
        onInputFunc: {
            default: () => {},
            type: Function,
        },
        onChangeFunc: {
            default: () => {},
            type: Function,
        },
        icon: {
            default: '',
            type: String,
        },
        disableMLtitle: {
            type: Boolean,
            default: false,
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required: {
            type: Boolean,
            default: false,
        },
        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null,
        },
        tooltipPosition: {
            type: String,
            default: 'is-right',
        },
        tooltipType: {
            type: String,
            default: 'is-dark',
        },
        tooltipMultilined: {
            type: Boolean,
            default: true,
        },
        tooltipSize: {
            type: String,
            default: 'is-large',
        },
        disableMLplaceholder: {
            type: Boolean,
            default: false,
        },
    },

    mounted() {
        this.focusedOut = !this.blur;

        let input = this.$refs.maskInput.$el;
        // input.addEventListener('blur', this.validateOnBlur);
    },
    data() {
        return {
            innerId: null,
            focusedOut: false,
        };
    },

    created() {
        if (this.id == null) {
            this.innerId = new Date().getTime() + '' + Math.floor(Math.random() * 10000);
        }
    },

    methods: {
        updateValue() {
            if (this.$refs.maskInput != undefined) {
                this.$emit('input', this.$refs.maskInput.lastValue);
            }
            this.onInputFunc();
        },
        inputAction() {
            this.$emit('input-action');
        },
        focusEvt() {
            this.focusedOut = false;

            if (this.onFocus) {
                this.onFocus();
            }
        },
        blurEvt() {
            this.focusedOut = true;

            if (this.blur) {
                this.focusedOut = true;
                this.onBlur();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
span.validation {
    font-size: 8px;
    color: $red;
    display: block;
    font-weight: 600;
}

.invalid {
    border: 1px solid $red-alert !important;
}

input {
    margin-bottom: 0 !important;
    color: #666666;
    height: 36px;
}

.field.has-addons {
    margin-bottom: 0;

    input {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
    }

    .button {
        height: 36px;
        color: #666666;
        border-color: $table-border;

        &.invalid-button {
            border-bottom-color: red;
            border-right-color: red;
            border-top-color: red;
        }
    }
}
</style>
